import React from "react";

function UserProfile(props) {
  return <div></div>;
}

export default UserProfile;
